module.exports = __webpack_public_path__ + "img/home-cases-1.06f9fc83.png";